import { useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import Container from '@Components/Container';
import { useStepper } from '@Components/Stepper';
import { initialValues } from '../../containers/RegisterContainer';
import { Header } from '@Components/Text';
import { SubTitle, SubTitleBlue } from '../styled';
import { ContainerTopBar } from './styled';

const TopBarRegister = () => {
	const stepper = useStepper();
	// const [isEmptyValue, setIsEmptyValue] = useState<boolean>(true);

	const formik = useFormikContext<typeof initialValues>();

	const { status } = formik;

	useEffect(() => {
		// if (
		// 	formik.values.firstname.length > 0 &&
		// 	formik.values.lastname.length > 0 &&
		// 	formik.values.email.length > 0 &&
		// 	!formik.errors.email &&
		// 	formik.values.levelTeacher.length > 0
		// ) {
		// 	setIsEmptyValue(false);
		// } else {
		// 	setIsEmptyValue(true);
		// }
	}, [
		formik.values.firstname,
		formik.values.lastname,
		formik.values.email,
		formik.values.levelTeacher,
	]);
	const goNext = () => {
		if (status.email === 'available') stepper.goNext();
	};

	const { currentStep } = stepper;
	const goBack = () => {
		stepper.goBack();
	};
	const intl = useIntl();

	return (
		<>
			{/* begin::Heading */}
			<div className=" d-flex justify-content-center">
				{/* begin::Title */}
				<Header className=" mb-3  " variant="h1" weight="bold">
					{intl.formatMessage({ id: 'AUTH.REGISTER.TOPBAR1' })}
				</Header>

				{/* end::Title */}

				{/* begin::Link */}
			</div>
			<div className="mb-5 text-center d-flex justify-content-center">
				<div className="d-flex align-items-center">
					<SubTitle className="">
						{intl.formatMessage({ id: 'AUTH.REGISTER.TOPBAR2' })}
					</SubTitle>
					<Link to="/auth/login">
						<SubTitleBlue>
							{intl.formatMessage({ id: 'AUTH.REGISTER.TOPBAR3' })}
						</SubTitleBlue>
					</Link>
				</div>
			</div>
			<div className="d-flex align-items-center mb-8">
				<div className="border-bottom border-gray-300 mw-50 w-100"></div>
				<div className="border-bottom border-gray-300 mw-50 w-100"></div>
			</div>
			{/* <div className="text-gray-400 fw-bold fs-4">
					{intl.formatMessage({ id: 'AUTH.REGISTER.TOPBAR2' })}
					<Link
						to="/auth/login"
						className="link-primary fw-bolder"
						style={{ marginLeft: '5px' }}
					>
						{intl.formatMessage({ id: 'AUTH.REGISTER.TOPBAR3' })}
					</Link>
				</div> */}
			{/* end::Link */}
			{/* end::Heading */}

			<Container className="mt-0 pt-0 mb-5 pb-2 d-flex justify-content-center">
				<ContainerTopBar>
					{currentStep === 1 ? (
						<>
							<Col className="col-6 pe-0">
								<p className="d-flex bg-primary border rounded justify-content-center align-items-center step-custom fw-bolder text-light fs-4 m-auto">
									{intl.formatMessage({ id: 'AUTH.REGISTER.TOPBAR4' })}
								</p>
							</Col>
							<Col className="col-6 ps-7">
								<p
									onClick={goNext}
									className="btn btn-primary on-mouse-enter-custom   d-flex bg-light border rounded justify-content-center align-items-center step-custom fw-bolder text-primary fs-4 m-auto"
								>
									{intl.formatMessage({ id: 'AUTH.REGISTER.TOPBAR5' })}
								</p>
							</Col>
						</>
					) : (
						currentStep === 2 && (
							<>
								<Col className="col-6 pe-0">
									<p
										onClick={goBack}
										className="btn btn-primary on-mouse-enter-custom   d-flex bg-light border rounded justify-content-center align-items-center step-custom fw-bolder text-primary fs-4 m-auto"
									>
										{intl.formatMessage({ id: 'AUTH.REGISTER.TOPBAR4' })}
									</p>
								</Col>
								<Col className="col-6 ps-7">
									<p className="d-flex bg-primary border rounded justify-content-center align-items-center step-custom fw-bolder text-light fs-4 m-auto">
										{intl.formatMessage({ id: 'AUTH.REGISTER.TOPBAR5' })}
									</p>
								</Col>
							</>
						)
					)}
				</ContainerTopBar>
			</Container>
		</>
	);
};

export default TopBarRegister;
